import React, { useEffect, useState } from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Avatar,
  Typography,
  Box,
  TablePagination,
  Button,
  IconButton,
} from '@mui/material';
import Swal from 'sweetalert2';
import { delunit, units, unitsApproved, unitsPending, unitsRejected, updateCancelationReq } from '../../../components/Apis';
import Unit from './unit'; // Make sure to create this component
import { styled } from "@mui/material/styles";
import Editunit from './Editunit';
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import Addunit from './Addunit';
import AlertDialog from '../../../components/modal/modal';
import { useTranslation } from 'react-i18next';
import DashboardSteps from './NewAddUnit';
import UnitSteps from './AddunitOld';
import { Navigate, useNavigate } from 'react-router-dom';
import Editnewunit from './EditNewUnit';
import UnitCalender from './UnitCalender';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';


const getStatusColor = (status) => {
  switch (status) {
    case "Approved":
      return { color: "green", label: "✔ Approved" };
    case "Pending":
      return { color: "orange", label: "⏳ Pending" };
    case "Canceled":
      return { color: "red", label: "✖ Canceled" };
    default:
      return { color: "black", label: status };
  }
};
const styles = {
  button: {
    backgroundColor: "#C97A62", // اللون البرتقالي الباهت
    color: "white", // لون النص
    border: "none", // إزالة الحدود
    borderRadius: "20px", // حواف دائرية
    padding: "10px 20px", // المساحة الداخلية
    fontSize: "16px", // حجم الخط
    fontWeight: "bold", // جعل النص عريضًا
    cursor: "pointer", // تغيير شكل المؤشر عند التمرير
    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)", // إضافة ظل خفيف
    display: "flex",
    alignItems: "center",
    gap: "8px", // مسافة بين النص والرمز
  },

};

const buttonStyle = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  backgroundColor: "#28a745", // Green background for approved status
  color: "white",
  border: "none",
  borderRadius: "5px",
  padding: "8px 16px",
  fontSize: "14px",
  fontWeight: "bold",
  cursor: "pointer",
  boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
  transition: "background-color 0.2s ease", // Added smooth color transition
  "&:hover": {
    backgroundColor: "#218838", // Slightly darker green on hover
  }
};
const Units = () => {
  const [Units, setUnits] = useState([]);
  const [Loading, setLoading] = useState(true);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [selectedButton, setSelectedButton] = useState('All');
  const [openUploadDialog, setOpenUploadDialog] = useState(false);
  const [openUploadDialog2, setOpenUploadDialog2] = useState(false);
  const [openUploadDialog3, setOpenUploadDialog3] = useState(false);
  const [editUnitId, seteditUnitId] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const { t, i18n } = useTranslation();
  const [render, setRender] = useState(false)
  const Rerender = () => { setRender(!render) }
  const navigate = useNavigate()



  const [selectedUnitId, setSelectedUnitId] = useState(null);
  const onclose = () => {
    setOpenUploadDialog(false)
  }
  const onclose2 = () => {
    setOpenUploadDialog2(false)
  }
  const onclose3 = () => {
    setOpenUploadDialog3(false)
  }

  useEffect(() => {
    const getUnits = async () => {
      Swal.fire({
        title: "Loading...",
        text: "Please wait while we load the data.",
        didOpen: () => {
          Swal.showLoading();
        },
      });

      try {
        const response = await units();
        console.log(response);
        setUnits(Array.isArray(response) ? response : []); // Ensure response is an array
        setLoading(false);
        Swal.close();
      } catch (error) {
        console.error(error.message);
        setLoading(false);
        Swal.close();
        setUnits([]); // Set Units to an empty array in case of error

      }
    };

    getUnits();
  }, [render]);

  const getPendingUnits = async () => {
    Swal.fire({
      title: "Loading...",
      text: "Please wait while we load the data.",
      didOpen: () => {
        Swal.showLoading();
      },
    });

    try {
      const response = await unitsPending();
      console.log(response);
      setUnits(Array.isArray(response) ? response : []); // Ensure response is an array
      setLoading(false);
      Swal.close();
    } catch (error) {
      console.error(error.message);
      setLoading(false);
      Swal.close();
      setUnits([]); // Set Units to an empty array in case of error

    }
  };


  const getRejectedUnits = async () => {
    Swal.fire({
      title: "Loading...",
      text: "Please wait while we load the data.",
      didOpen: () => {
        Swal.showLoading();
      },
    });

    try {
      const response = await unitsRejected();
      console.log(response);
      setUnits(Array.isArray(response) ? response : []); // Ensure response is an array
      setLoading(false);
      Swal.close();
    } catch (error) {
      console.error(error.message);
      setLoading(false);
      Swal.close();
      setUnits([]); // Set Units to an empty array in case of error

    }
  };

  const getApporvedUnits = async () => {
    Swal.fire({
      title: "Loading...",
      text: "Please wait while we load the data.",
      didOpen: () => {
        Swal.showLoading();
      },
    });

    try {
      const response = await unitsApproved();
      console.log(response);
      setUnits(Array.isArray(response) ? response : []); // Ensure response is an array
      setLoading(false);
      Swal.close();
    } catch (error) {
      console.error(error.message);
      setLoading(false);
      Swal.close();
      setUnits([]); // Set Units to an empty array in case of error

    }
  };




  const getUnits = async () => {
    Swal.fire({
      title: "Loading...",
      text: "Please wait while we load the data.",
      didOpen: () => {
        Swal.showLoading();
      },
    });

    try {
      const response = await units();
      console.log("units",response);
      setUnits(Array.isArray(response) ? response : []); // Ensure response is an array
      setLoading(false);
      Swal.close();
    } catch (error) {
      console.error(error.message);
      setLoading(false);
      Swal.close();
      setUnits([]); // Set Units to an empty array in case of error
    }
  };



  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };

  const handleRowsPerPageChange = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleRowClick = (id) => {
    setSelectedUnitId(id);

    function date() {

    }
  };

  const handleBackToList = () => {
    setSelectedUnitId(null);
  };

  // Calculate data for the current page
  const paginatedData = (Array.isArray(Units) ? Units : []).slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );
  console.log(paginatedData.map((ele) => { console.log("pagination", ele.unit); }))

  const containerStyle = {
    display: 'flex',
    flexDirection: 'row', // ترتيب الأزرار جنب بعض
    alignItems: 'center', // محاذاة الأزرار بشكل مركزي
    paddingInline: '4px', // مسافة داخلية للحاوية
    paddingBlock: '10px', // مسافة داخلية للحاوية
    borderRadius: '10px', // حواف خلفية دائرية
    backgroundColor: '#C47D601F', // لون الخلفية
    boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)', // ظل للخلفية
  };

  const buttonStyle = (isSelected) => {
    const isMobile = typeof window !== 'undefined' && window.innerWidth <= 600;
    return {
      display: 'inline-block',
      padding: isMobile ? '8px 20px' : '10px 40px',
      backgroundColor: isSelected ? '#C47D60' : 'transparent',
      color: isSelected ? 'white' : '#C47D60',
      borderRadius: '10px',
      fontFamily: 'Arial, sans-serif',
      fontSize: isMobile ? '12px' : '16px',
      textAlign: 'center',
      cursor: 'pointer',
      userSelect: 'none',
      border: 'none',
      margin: '0 10px',
      transition: 'background-color 0.2s, transform 0.2s',
    };
  };
  const AcceptButton = styled(Button)(({ theme }) => ({
    backgroundColor: "#c69e8d", // لون زر القبول
    color: "#fff",
    borderRadius: "10px",
    padding: "8px 16px",
    textTransform: "none",
    fontWeight: "bold",
    "&:hover": {
      backgroundColor: "#b18577", // لون التفاعل عند المرور بالماوس
    },
  }));

  const RejectButton = styled(Button)(({ theme }) => ({
    color: "#e70000",
    border: "2px solid #e70000", // لون زر الرفض
    borderRadius: "10px",
    padding: "8px 16px",
    textTransform: "none",
    fontWeight: "bold",
    "&:hover": {
      backgroundColor: "#ffe6e6", // خلفية عند التفاعل بالماوس
    },
  }));
  const handleClick = (button) => {
    setSelectedButton(button);

    switch (button) {
      case 'All':
        getUnits();
        break;
      case 'Approved':
        getApporvedUnits();
        break;
      case 'Rejected':
        getRejectedUnits();
        break;
      case 'Pending':
        getPendingUnits();
        break;
      case 'History':
        getUnits();
        break;
      default:
        break;
    }
  };

  const haandleApproved = async (id) => {
    const formData = new FormData();
    formData.append("status", "approved");
    formData.forEach((value, key) => {
      console.log(`${key}: ${value}`);
    });
    const res = await updateCancelationReq(id, formData);
    console.log(res)
    getUnits()
  }
  const haandleRejected = async (id) => {
    const formData = new FormData();
    formData.append("status", "rejected");
    formData.forEach((value, key) => {
      console.log(`${key}: ${value}`);
    });
    const res = await updateCancelationReq(id, formData);
    console.log(res)
    getUnits()
  }

  const handleDeleteClick = async (id, e) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    
    const result = await Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!',
    });

    if (result.isConfirmed) {
      try {
        await delunit(id);
        setUnits((prevUnits) =>
          prevUnits.filter((unit) => unit.id !== id)
        );
        Swal.fire('Deleted!', 'Unit has been deleted.', 'success');
      } catch (error) {
        console.error('Error deleting Unit:', error);
        Swal.fire('Error!', 'Failed to delete the Unit.', 'error');
      }
    }
  };

  return (
    <Box sx={{ 
      p: { xs: 1, sm: 2, md: 3 }, 
      direction: 'ltr', 
      backgroundColor: "var(--seco-col)", 
      minHeight: "100vh", 
      position: "relative",
      overflow: 'hidden'
    }}>
      {!selectedUnitId ? (
        <>
          <Box sx={{ 
            display: 'flex', 
            justifyContent: 'space-between', 
            alignItems: 'center', 
            mb: { xs: 2, sm: 3 },
            flexDirection: i18n.language === 'ar' ? 'row-reverse' : 'row',
            flexWrap: 'wrap',
            gap: 2
          }}>
            <Typography variant="h6" sx={{ fontSize: { xs: '1.1rem', sm: '1.25rem' } }}> 
              {t('My Units')}
            </Typography>
          </Box>

          <Box sx={{
            display: 'flex',
            flexDirection: { xs: 'column', sm: 'row' },
            justifyContent: 'space-between',
            alignItems: { xs: 'stretch', sm: 'center' },
            gap: 2,
            paddingBlock: '20px',
          }}>
            <Box sx={{
              ...containerStyle,
              width: { xs: '100%', sm: 'auto' },
              overflowX: { xs: 'auto', sm: 'visible' },
              flexWrap: { xs: 'nowrap', sm: 'wrap' },
              padding: { xs: '8px', sm: '4px' }
            }}>
              <div
                style={buttonStyle(selectedButton === 'All')}
                onClick={() => handleClick('All')}
              >
                {t('all')}
              </div>
              <div
                style={buttonStyle(selectedButton === 'Approved')}
                onClick={() => handleClick('Approved')}
              >
                {t('live')}

              </div>
              <div
                style={buttonStyle(selectedButton === 'Pending')}
                onClick={() => handleClick('Pending')}
              >
                {t('Pending Review')}
              </div>

              {/* <div
                style={buttonStyle(selectedButton === 'History')}
                onClick={() => handleClick('History')}
              >
                History
              </div> */}
              {/* <div
                style={buttonStyle(selectedButton === 'Rejected')}
                onClick={() => handleClick('Rejected')}
              >
                Cancelled

              </div> */}
            </Box>
            
            <IconButton
              onClick={() => navigate("/Addunits")}
              sx={{
                alignSelf: { xs: 'flex-end', sm: 'center' },
                zIndex: "5",
                border: 'none',
                borderRadius: 2,
                "&:hover": {
                  backgroundColor: "transparent",
                  color: "#fff",
                }
              }}
            >
              <AddIcon sx={{
                color: "#C47D60", 
                fontSize: { xs: "2rem", sm: "3rem" },
                "&:hover": {
                  backgroundColor: "transparent",
                  color: "#fff",
                }
              }} />
            </IconButton>
          </Box>


          {Array.isArray(Units) && Units.length > 0 ? (
            <>
              <TableContainer 
                component={Paper} 
                sx={{ 
                  marginTop: "2rem",
                  overflowX: 'auto',
                  width: '100%',
                  '& .MuiTable-root': {
                    minWidth: { xs: '100%', sm: 750, md: 900 }
                  }
                }}
              >
                <Table 
                  dir={i18n.language === 'ar' ? 'rtl' : 'ltr'} 
                  sx={{ 
                    tableLayout: 'fixed',
                    width: '100%'
                  }}
                >
                  <TableHead style={{ backgroundColor: "#F2F4F7" }}>
                    <TableRow>
                      <TableCell align="center" sx={{ 
                        width: { xs: '25%', sm: '16.66%' },
                        fontSize: { xs: '0.75rem', sm: '1rem' },
                        padding: { xs: '8px 4px', sm: '16px' }
                      }}>
                        {t('UnitName')}
                      </TableCell>
                      <TableCell align="center" sx={{ 
                        width: { xs: '25%', sm: '16.66%' },
                        fontSize: { xs: '0.75rem', sm: '1rem' },
                        padding: { xs: '8px 4px', sm: '16px' }
                      }}>
                        {t('UnitStatus')}
                      </TableCell>
                      <TableCell align="center" sx={{ 
                        width: { xs: '25%', sm: '16.66%' },
                        fontSize: { xs: '0.75rem', sm: '1rem' },
                        padding: { xs: '8px 4px', sm: '16px' }
                      }}>
                        {t('Created')}
                      </TableCell>
                      <TableCell align="center" sx={{ 
                        width: { xs: '25%', sm: '16.66%' },
                        fontSize: { xs: '0.75rem', sm: '1rem' },
                        padding: { xs: '8px 4px', sm: '16px' }
                      }}>
                        {t('Calender')}
                      </TableCell>
                      <TableCell align="center" sx={{ 
                        width: { xs: '25%', sm: '16.66%' },
                        fontSize: { xs: '0.75rem', sm: '1rem' },
                        padding: { xs: '8px 4px', sm: '16px' }
                      }}>
                        {t('Edit')}
                      </TableCell>
                      <TableCell align="center" sx={{ 
                        width: { xs: '25%', sm: '16.66%' },
                        fontSize: { xs: '0.75rem', sm: '1rem' },
                        padding: { xs: '8px 4px', sm: '16px' }
                      }}>
                        {t('Delete')}
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {paginatedData.filter((record) => record.status !== "rejected")
                      .map((record) => (
                        <TableRow
                          key={record.id}
                          sx={{
                            "&:hover": {
                              backgroundColor: "rgba(0, 0, 0, 0.04)",
                              cursor: "pointer",
                            },
                          }}
                        >
                          <TableCell align="center" sx={{ 
                            fontSize: { xs: '0.75rem', sm: '1rem' },
                            padding: { xs: '8px 4px', sm: '16px' }
                          }}>
                            {record.name}
                          </TableCell>
                          <TableCell align="center" sx={{ 
                            fontSize: { xs: '0.75rem', sm: '1rem' },
                            padding: { xs: '8px 4px', sm: '16px' }
                          }}>
                            {record.status === "pending" ? (
                              <button style={{
                                width: { xs: "80%", sm: "60%" },
                                backgroundColor: "rgba(255, 161, 80, 0.12)",
                                color: "#FFA150",
                                border: "1px solid #FFA150",
                                borderRadius: "5px",
                                padding: { xs: "4px 8px", sm: "8px 16px" },
                                fontSize: { xs: "12px", sm: "14px" },
                                fontWeight: "bold",
                                cursor: "pointer",
                                boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                              }}>
                                {t(' Pending')}
                              </button>
                            ) : record.status === "approved" ? (
                              <button style={{
                                width: { xs: "80%", sm: "60%" },
                                backgroundColor: "rgba(3, 152, 85, 0.12)",
                                color: "#039855",
                                border: "1px solid #039855",
                                borderRadius: "5px",
                                padding: { xs: "4px 8px", sm: "8px 16px" },
                                fontSize: { xs: "12px", sm: "14px" },
                                fontWeight: "bold",
                                cursor: "pointer",
                                boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                              }}>
                                {t('Live')}
                              </button>
                            ) : null}
                          </TableCell>
                          <TableCell align="center" sx={{ 
                            fontSize: { xs: '0.75rem', sm: '1rem' },
                            padding: { xs: '8px 4px', sm: '16px' }
                          }}>
                            {record.created_at}
                          </TableCell>
                          <TableCell align="center" sx={{ 
                            fontSize: { xs: '0.75rem', sm: '1rem' },
                            padding: { xs: '8px 4px', sm: '16px' }
                          }}>
                            <IconButton
                              color="secondary"
                              onClick={() => {
                                seteditUnitId(record.id);
                                setOpenUploadDialog3(true);
                              }}
                              sx={{
                                backgroundColor: "transparent",
                                color: "#C47D60",
                                padding: { xs: '4px', sm: '8px' }
                              }}
                            >
                              <CalendarTodayIcon sx={{ fontSize: { xs: '1.2rem', sm: '1.5rem' } }} />
                            </IconButton>
                          </TableCell>
                          <TableCell align="center" sx={{ 
                            fontSize: { xs: '0.75rem', sm: '1rem' },
                            padding: { xs: '8px 4px', sm: '16px' }
                          }}>
                            <IconButton
                              color="secondary"
                              onClick={() => {
                                navigate("/Editnewunit", { state: { unitId: record.id } });
                              }}
                              sx={{
                                backgroundColor: "transparent",
                                color: "#C47D60",
                                padding: { xs: '4px', sm: '8px' }
                              }}
                            >
                              <EditIcon sx={{ fontSize: { xs: '1.2rem', sm: '1.5rem' } }} />
                            </IconButton>
                          </TableCell>
                          <TableCell align="center" sx={{ 
                            fontSize: { xs: '0.75rem', sm: '1rem' },
                            padding: { xs: '8px 4px', sm: '16px' }
                          }}>
                            <IconButton
                              color="secondary"
                              onClick={(e) => handleDeleteClick(record.id, e)}
                              sx={{
                                backgroundColor: "transparent",
                                color: "#C47D60",
                                padding: { xs: '4px', sm: '8px' },
                                pointerEvents: "auto",
                                zIndex: 2
                              }}
                            >
                              <DeleteIcon sx={{ fontSize: { xs: '1.2rem', sm: '1.5rem' } }} />
                            </IconButton>
                          </TableCell>
                        </TableRow>
                      ))}
                  </TableBody>
                </Table>
              </TableContainer>

              <TablePagination
                component="div"
                count={Units.length}
                page={page}
                onPageChange={handlePageChange}
                rowsPerPage={rowsPerPage}
                onRowsPerPageChange={handleRowsPerPageChange}
                rowsPerPageOptions={[5, 10, 25]}
                sx={{
                  '.MuiTablePagination-select': {
                    fontSize: { xs: '0.875rem', sm: '1rem' }
                  },
                  '.MuiTablePagination-displayedRows': {
                    fontSize: { xs: '0.875rem', sm: '1rem' }
                  }
                }}
              />
            </>
          ) : (
            <Typography
              variant="h6"
              sx={{
                textAlign: "center",
                marginTop: "20px",
                color: "gray",
                fontSize: { xs: '1rem', sm: '1.25rem' }
              }}
            >
              No Units Found
            </Typography>
          )}

        </>
      ) : (
        <Box>
          <Button variant="contained" onClick={handleBackToList} sx={{ mb: 3, backgroundColor: 'var(--pri-col)', "&:hover": { backgroundColor: "var(--pri-col)", } }}>
            Back to Units List
          </Button>
          <Unit unitId={selectedUnitId} />
        </Box>
      )}
      <Editunit
        open={openUploadDialog}
        unitId={editUnitId}
        // onFileChange={handleFileChange}
        onClose={onclose}
        rendr={Rerender}
      // onSubmit={handleUploadSubmit}
      />

      <Addunit
        open={openUploadDialog2}
        // onFileChange={handleFileChange}
        onClose={onclose2}
        rendr={Rerender}
      // onSubmit={handleUploadSubmit}
      />
      <UnitCalender
        open={openUploadDialog3}
        unitId={editUnitId}
        onClose={onclose3}
        rendr={Rerender}
      // onSubmit={handleUploadSubmit}
      />
      <Box
        component="img"
        src="../../assets/image 4.png"
        sx={{
          width: { xs: "150px", sm: "200px", md: "250px" },
          height: { xs: "270px", sm: "360px", md: "450px" },
          position: "absolute",
          top: "10px",
          right: { xs: "-20px", sm: "-30px", md: "-40px" },
          zIndex: "1",
          transform: "rotate(0deg)",
          display: { xs: 'none', sm: 'block' }
        }}
      />
    </Box>
  );
};

export default Units;